import { getSignalRConnector } from '@/api/signalR/SignalRConnector.ts';
import { logger } from '@/components/SgwtBootstrap/logger.ts';
import { bulkTradeApi } from '@/store/bulkTrade/api';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';

const heartbeatListenersByRfsId: Record<string, (rfsId: string) => void> = {};

export const registerRfsBulkListeners = (startAppListening: StartAppListening) => {
  startAppListening({
    matcher: bulkTradeApi.endpoints.requestBulkTradeRfs.matchFulfilled,
    effect: async (action, api) => {
      const { rfsId, tabId } = action.meta.arg.originalArgs;
      const signalRConnector = getSignalRConnector();

      function onHeartbeatTimeout(id: string) {
        if (id !== rfsId) {
          return;
        }
        logger.logError('[BULKTRADE] heartbeat timeout {error_s}', JSON.stringify({ tabId, rfsId }));

        api.dispatch(
          bulkTradeApi.endpoints.cancelBulkTradeRfs.initiate({
            tabId,
            rfsId,
          }),
        );
      }

      heartbeatListenersByRfsId[rfsId] = onHeartbeatTimeout;
      signalRConnector.onHeartbeatTimeout(rfsId, onHeartbeatTimeout);
    },
  });

  startAppListening({
    matcher: bulkTradeApi.endpoints.executeBulkTradeRfs.matchPending,
    effect: async (action) => {
      const { rfsId } = action.meta.arg.originalArgs;
      const listener = heartbeatListenersByRfsId[rfsId];
      if (listener) {
        getSignalRConnector().offHeartbeatTimeout(rfsId, listener);
        delete heartbeatListenersByRfsId[rfsId];
      }
    },
  });

  startAppListening({
    matcher: bulkTradeApi.endpoints.executeBulkTradeRfs.matchRejected,
    effect: async (action, { dispatch }) => {
      const { rfsId, tabId } = action.meta.arg.originalArgs;
      dispatch(
        bulkTradeApi.endpoints.cancelBulkTradeRfs.initiate({
          tabId,
          rfsId,
        }),
      );
    },
  });

  startAppListening({
    matcher: bulkTradeApi.endpoints.cancelBulkTradeRfs.matchPending,
    effect: async (action) => {
      const { rfsId } = action.meta.arg.originalArgs;

      const listener = heartbeatListenersByRfsId[rfsId];
      if (listener) {
        getSignalRConnector().offHeartbeatTimeout(rfsId, listener);
        delete heartbeatListenersByRfsId[rfsId];
      }
    },
  });
};
